import { PdfApi } from "../Apis/PdfApi";
import { ContractConditionsViewModel } from "../ViewModels/ContractConditionsViewModel";
import * as ko from "knockout";

export class ContractConditions {
    pdfApi: PdfApi;
    viewModel: ContractConditionsViewModel;
    $conditionsTable: JQuery;
    constructor() {
        this.viewModel = new ContractConditionsViewModel;
        this.pdfApi = PdfApi.getInstance();
        this.$conditionsTable = $("#contracts-conditions-table");
        if (this.$conditionsTable[0]) {
            ko.applyBindings(this.viewModel,this.$conditionsTable[0]);
        }
    }

    init(): void {
        this.pdfApi.getContractConditions().then((res) => {
            this.viewModel.completeList(res);
            this.attachPdfDownloadJquery();
        });
    }
    private attachPdfDownloadJquery(): void {
        const self = this;
        self.$conditionsTable.on('click', '[id *= download]', function (e: any) {
            const id = $(this).attr('id');
            const fileName = $(this).attr('filename');
            const entryNo = Number.parseInt(id.split('download')[1]);
            const company = $(this).attr('company');
            self.pdfApi.downloadFile(entryNo, fileName, company);
        });
    }
}